import { Injectable } from '@angular/core';
import { ExportChannel } from '../models/new/export-channel';

@Injectable({
  providedIn: 'root'
})
export class ExportChannelMapper {
  toExportChannel(node: any) {
    return new ExportChannel({
      id: node.id,
      code: node.code,
      name: node.name,
      label: node.code,
      usesCodifiedUses: !!node.usesCodifiedUses
    });
  }

  toWhereClauseById(id: number) {
    return { id: { eq: id } };
  }
}
